import React from "react";
import classes from "../style/main.module.css";

export const MustLogIn: React.FC = () => (
  <div className={classes.loginContainer}>
    You need to login
    <br />
    <br />
    <form
      method="GET"
      action={`../../../..${process.env.PUBLIC_URL}/federation/snap`}
    >
      <input type="submit" className={classes.button} value="Login" />
    </form>
  </div>
);
